import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Button, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import { Status } from "../../routes/doa-forecast/DoaForecastModels";
import { getKeyByValue } from "../../utils";
import { Disclaimer } from "./Disclaimer";
import { disclaimerContentStyle, disclaimerStyle, dispatchInfoTableStyle } from "./styled";

export interface IDispatchInfoBoxProps {
  date: string;
  dispatchDescription: string;
  dispatch?: string;
  availabilityStatus: Status,
  dispatchStatus: Status,
  rows: [string, string | ReactNode][],
  onSelectDispatch?: (dispatch: string, date: string) => void,
  refreshContext?: string,
  refreshTime?: string,
}

export const DispatchInfoBox: React.FC<IDispatchInfoBoxProps> = ({
  date,
  dispatch,
  availabilityStatus,
  dispatchStatus,
  rows,
  onSelectDispatch,
  dispatchDescription,
  refreshContext,
  refreshTime
}) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const onShowDisclaimer = () => setShowDisclaimer(prev => !prev);
  return (
    <Table size="custom" className="info-box" sx={dispatchInfoTableStyle}>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2}>
            <Box sx={{ pb: 1, display: 'flex', justifyContent: onSelectDispatch ? 'center' : 'space-between' }}>
              <Typography data-automation='dispatch-date-shift'>{date} - {dispatchDescription}</Typography>
              {showDisclaimer &&
                <Box sx={disclaimerContentStyle}>
                  <Disclaimer context={refreshContext || ''} time={refreshTime || ''} handleClick={onShowDisclaimer} />
                </Box>
              }
              {!onSelectDispatch && <Box
                component='span'
                sx={disclaimerStyle}
                onClick={onShowDisclaimer}
              >
                <HelpOutlineIcon sx={{ marginRight: "3px" }} />
                <Typography data-automation="disclaimer-label">Help</Typography>
              </Box>}
            </Box>
            <Typography>
              Availability Status:
              <Typography data-automation='availability-status' component='span' className={getKeyByValue(Status, availabilityStatus)}> {availabilityStatus}</Typography>
            </Typography>
            <Typography>
              Physical Dispatch Status:
              <Typography data-automation='physical-dispatch-status' component='span' className={getKeyByValue(Status, dispatchStatus)}> {dispatchStatus}</Typography>
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {
          rows.map(([c1, c2]) => (
            <TableRow key={c1}>
              <TableCell data-automation='jobs-required'>{c1}</TableCell>
              <TableCell data-automation='total-emp-using-doa'>{c2}</TableCell>
            </TableRow>
          ))
        }
      </TableBody>
      {onSelectDispatch && dispatch && <TableFooter>
        <TableRow>
          <TableCell colSpan={2}>
            <Button
              variant="contained"
              size="medium"
              data-automation='view-forecast'
              onClick={() => onSelectDispatch(dispatch, date)}
            >
              View Forecast
            </Button>
          </TableCell>
        </TableRow>
      </TableFooter>}
    </Table>
  )
}